import SmallCircleLoader from 'Assets/Images/SmallCircleLoader.svg';
import React from 'react';

const Spinner = ({
    altText,
    className,
}: {
    altText?: string;
    className?: string;
}) => (
    <div className={className}>
        <img src={SmallCircleLoader} alt={altText} />
    </div>
);

export default Spinner;
